import request from "@/config/utils/request";

// 查询用户手册树形列表
export function getUserManualTreeList(data) {
  return request({
    url: "/apis/bid/hc/userManual/listUserManualTree", // 后端接口
    method: "post",
    data
  });
}

// 查询用户手册正文内容
export function getUserManualTextContent(data) {
  return request({
    url: "/apis/bid/hc/userManual/getUserManualTextContent", // 后端接口
    method: "post",
    data
  });
}
